module.exports = __webpack_public_path__ + "static/fonts/DejaVuSerif-Italic.08f58f7.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/shared-components/spreadsheet/kendoui/fonts/DejaVu/DejaVuSerif-Italic.ttf?v=1.1
// module id = 1639
// module chunks = 28